import React from "react"
import { PaginationLink } from "./pagination-link"
import { cn } from '@/utils/index'
import { ArrowRightCircle } from "lucide-react"

export const PaginationNext = React.forwardRef<HTMLAnchorElement, React.ComponentProps<typeof PaginationLink>>(
  ({ className, disabled, ...props }, ref) => (
    <PaginationLink
      ref={ref}
      aria-label="Go to next page"
      size="lg"
      className={cn(
        "flex size-8 items-center justify-center border-0 px-0 py-0 transition-transform disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      disabled={disabled}
      {...props}
    >
      <ArrowRightCircle size={50} />
    </PaginationLink>
  )
)
PaginationNext.displayName = "PaginationNext"
